import { z } from 'zod';

const slotInputSchema = z.object({
  id: z.number().int().positive().optional(),
  label: z.string().max(255).optional(),
  order: z.number().int().optional(),
  scheduledAt: z.coerce.date(),
  language: z.string().length(2).optional(),
  timezone: z.string().max(50).optional(),
});

export const sessionProgramCreateSchema = z.object({
  name: z.string().min(1).max(255),
  description: z.string().max(2000).optional(),
  gameMode: z.enum(['teamlab', 'leadlab']),
  isActive: z.boolean().optional(),
  slots: z.array(
    z.object({
      label: z.string().max(255).optional(),
      order: z.number().int().optional(),
      scheduledAt: z.coerce.date(),
      language: z.string().length(2).optional(),
      timezone: z.string().max(50).optional(),
    })
  ).optional(),
});

export const sessionProgramUpdateSchema = sessionProgramCreateSchema.partial().extend({
  slots: z.array(slotInputSchema).optional(),
});

export type SessionProgramCreateInput = z.infer<typeof sessionProgramCreateSchema>;
export type SessionProgramUpdateInput = z.infer<typeof sessionProgramUpdateSchema>;
